import { render } from "./InventoryReports.vue?vue&type=template&id=77ea8492&ts=true"
import script from "./InventoryReports.vue?vue&type=script&lang=ts"
export * from "./InventoryReports.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__